<ng-container *ngFor="let tab of tabs">
  <button (click)="changeTab(tab)" class="animated fadeIn font14 b-radius unset-outline unset-box-shadow rad-tab"
    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textBlack'"
    [ngStyle]="{'border': tab.selected ? (settings.darkModeSetting ? '2px solid #fff' : '2px solid var(--green)') : ('2px solid transparent')}">
    <span>{{tab.groupName}}</span>
  </button>
  <ng-template [ngIf]="tab.selected">
    <div class="animated fadeIn absolute box-shadow b-radius full-width overflow-auto rad-container"
      [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <ng-template [ngIf]="favouritedActions.length > 0 && tab.groupName == app.translations.GBL_lbl_ActionsText">
        <div class="row" style="margin-bottom: 5px !important;">          
          <ng-container *ngFor="let favAction of favouritedActions">            
            <div class="col-4 cursorPointer b-radius relative unset-p">              
              <button class="font13 b-radius padding5" type="button" [disabled]="favAction.action.disabled"
                (click)="loadAction(favAction.action)" style="border: 2px solid var(--green) !important;"
                [ngClass]="{'rad-btn-dark': settings.darkModeSetting && !favAction.action.disabled, 
                    'rad-btn-light': !settings.darkModeSetting && !favAction.action.disabled, 
                    'rad-btn-disabled': favAction.action.disabled, 'rad-btn': !favAction.action.disabled, 
                    'textWhite bg-dark-secondary': settings.darkModeSetting, 'textBlack bg-light-blue': !settings.darkModeSetting}"
                [ngStyle]="{'cursor': favAction.action.disabled ? 'not-allowed' : 'pointer', 'cursor': favAction.action.disabled ? 'not-allowed' : 'pointer'}">
                <span>{{favAction.groupName}}</span><br>
                <ng-template [ngIf]="favAction.action.imageIcon != null && !mobileView">
                  <img [src]="'data:image/png;base64,' + favAction.action.imageIcon" width="25" height="25" />
                </ng-template>                
                {{favAction.action.name}}
              </button>
              <fa-icon [icon]="faStarSolid" class="absolute font15 cursorPointer textGreen" style="right: 10px; top: 5px;"
                (click)="unfavouriteAction(favAction, undefined, undefined)"></fa-icon>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-container *ngFor="let group of tab.data">
        <div class="row" style="margin-bottom: 5px !important;">
          <div class="col-12 cursorPointer b-radius padding5 rad-group-container"
            [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'" (click)="expandGroup(group);">
            <span class="font15 rad-group-title inline-block"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
              {{group.key}}
            </span>
          </div>
          <ng-template [ngIf]="group.expanded">
            <ng-container *ngFor="let button of group.value">
              <div class="animated fadeIn rad-group b-radius unset-p relative">
                <ng-template [ngIf]="tab.groupName == app.translations.GBL_lbl_ActionsText">
                  <button class="font13 b-radius padding5" type="button" [disabled]="button.disabled"
                    (click)="loadAction(button)"
                    [ngClass]="{'rad-btn-dark': settings.darkModeSetting && !button.disabled, 'rad-btn-light': !settings.darkModeSetting && !button.disabled, 
                    'rad-btn-disabled': button.disabled, 'rad-btn': !button.disabled, 
                    'textWhite bg-dark-secondary': settings.darkModeSetting, 'textBlack bg-light-blue': !settings.darkModeSetting}"
                    [ngStyle]="{'cursor': button.disabled ? 'not-allowed' : 'pointer', 'cursor': button.disabled ? 'not-allowed' : 'pointer'}">
                    <ng-template [ngIf]="button.imageIcon != null">
                      <img [src]="'data:image/png;base64,' + button.imageIcon" width="25" height="25" />
                    </ng-template>
                    {{button.name}}
                  </button>
                  <fa-icon [icon]="button.favourited ? faStarSolid : faStarRegular"
                    class="absolute font15 cursorPointer textGreen" style="right: 15px; top: 50%; transform: translateY(-50%)"
                    (click)="button.favourited ? unfavouriteAction(undefined, button, group.key) : favouriteAction(button, group)"></fa-icon>
                </ng-template>
                <ng-template [ngIf]="tab.groupName == app.translations.GBL_lbl_ReportText">
                  <button class="font13 b-radius padding5" type="button" [disabled]="button.disabled"
                    (click)="loadReport(button)"
                    [ngClass]="{'rad-btn-dark': settings.darkModeSetting && !button.disabled, 'rad-btn-light': !settings.darkModeSetting && !button.disabled, 
                    'rad-btn-disabled textGreyb9': button.disabled, 'rad-btn': !button.disabled, 
                    'textWhite bg-dark-secondary': settings.darkModeSetting, 'textBlack bg-light-blue': !settings.darkModeSetting}"
                    [ngStyle]="{'cursor': button.disabled ? 'not-allowed' : 'pointer'}">
                    <ng-template [ngIf]="button.icon != null">
                      <img [src]="'data:image/png;base64,' + button.icon" width="25" height="25" />
                    </ng-template>
                    {{button.name}}
                  </button>
                </ng-template>
                <ng-template [ngIf]="tab.groupName == app.translations.GBL_lbl_DashboardsText">
                  <button class="font13 b-radius padding5" type="button" [disabled]="button.disabled"
                    (click)="loadDashboard(button)"
                    [ngClass]="{'rad-btn-dark': settings.darkModeSetting && !button.disabled, 'rad-btn-light': !settings.darkModeSetting && !button.disabled, 
                    'rad-btn-disabled': button.disabled, 'rad-btn': !button.disabled, 
                    'textWhite bg-dark-secondary': settings.darkModeSetting, 'textBlack bg-light-blue': !settings.darkModeSetting}"
                    [ngStyle]="{'cursor': button.disabled ? 'not-allowed' : 'pointer'}">
                    <ng-template [ngIf]="button.icon != null">
                      <img [src]="'data:image/png;base64,' + button.icon" width="25" height="25" />
                    </ng-template>
                    {{button.name}}
                  </button>
                </ng-template>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </ng-template>
</ng-container>